export default __webpack_public_path__ + "static/media/CombustionImg.7f25a705.jpg";